import React from 'react';
import { ApryseSDK } from '../../../../pdf/ApryseSDK';
import { concatClassNames, toGermanTimestring, translatePrettyType } from '../../../../utils';
import { GlobalVariables } from '../../../../pdf/GlobalVariables';
import i18next from 'i18next';
import { ListItemIcon, ListItemText, MenuItem, Typography } from '@mui/material';

import styles from './ScrollToSelectedMenuItem.module.scss';

const ScrollToSelectedMenuItem = ({ isChosen, child }) => {
    const { annotation } = child;
    const menuItemRef = React.useRef<HTMLLIElement>(null);
    React.useEffect(() => {
        if (isChosen && menuItemRef.current) {
            menuItemRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [isChosen]);

    return (
        <MenuItem
            ref={menuItemRef}
            className={
                isChosen
                    ? concatClassNames(styles.sidebarSecondaryListItem, styles.iconButtonSelected)
                    : styles.sidebarSecondaryListItem
            }
            key={child.key}
            sx={{ pl: 4 }}
            onClick={() => {
                if (annotation.PageNumber !== null) {
                    ApryseSDK.markAnnotAsSelected(annotation);
                    GlobalVariables.zoom(0, annotation);
                }
            }}
            onContextMenu={mouseEvent => {
                mouseEvent.preventDefault();
                ApryseSDK.textAnnotationCopyTextContext = null;
                if (ApryseSDK.isFreeTextAnnotation(annotation) !== null) {
                    ApryseSDK.textAnnotationCopyTextContext = annotation;
                    ApryseSDK.showContextMenuForAnnotation(
                        mouseEvent.currentTarget,
                        {
                            x: mouseEvent.clientX,
                            y: mouseEvent.clientY,
                        },
                        annotation,
                    );
                }
            }}
        >
            <ListItemIcon className={styles.sidebarSecondaryListIcon}>{child.icon}</ListItemIcon>
            <ListItemText title={annotation.getContents()}>
                <Typography sx={{ fontSize: '14px', whiteSpace: 'pre-line' }}>
                    {i18next.t('sidebar.popups.page') +
                        ' ' +
                        annotation.PageNumber +
                        ' - ' +
                        child.text}
                    <br />
                    {translatePrettyType(annotation)}
                    {child.text !== 'EPLASS Schriftfeld' &&
                        ApryseSDK.getCreationTime(annotation) && (
                            <>
                                <br />
                                {toGermanTimestring(ApryseSDK.getCreationTime(annotation))}
                            </>
                        )}
                    {ApryseSDK.isFreeTextAnnotation(annotation) ? (
                        <>
                            <br />
                            {annotation.getContents()}
                        </>
                    ) : null}
                </Typography>
            </ListItemText>
        </MenuItem>
    );
};

export default ScrollToSelectedMenuItem;
